import styled from 'styled-components'

import { _XS_Normal, mainColors } from '@avantstay/backoffice-core'

export const Name = styled.span`
  ${_XS_Normal};
  display: block;
  color: ${mainColors.neutralExtremelyDark};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-decoration: underline dotted;
  cursor: default;
`

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const DetailLine = styled.span`
  ${_XS_Normal};
`
